import { Component } from '@angular/core';
import { APP_CONFIG } from '@shared/config/app.config';
import { SplitService } from './shared/services/split.service';
import { IconRegistryService } from './shared/services/icon-registry.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent {
  title = 'RappiPay | Customer Care';
  environmentName = APP_CONFIG.name;
  appVersion = APP_CONFIG.version;
  isProd = APP_CONFIG.production;

  constructor(
    private readonly _splitSvc: SplitService,
    private readonly _iconRegistrySvc: IconRegistryService
  ) {
    this._splitSvc.initSdk();
    this._iconRegistrySvc.setCustomIcons();
  }
}
